import { fmtDag, type Wijziging } from '@ep/core';

/** SPEC §10 – wijzigingslog: per versie titel, datum en punten; optioneel met de datum waarop hij live ging. */
export function WijzigingenLijst({ wijzigingen, live, huidig }: { wijzigingen: Wijziging[]; live?: Map<string, string>; huidig?: string }) {
  return (
    <div className="kolom" style={{ gap: 14 }}>
      {wijzigingen.map((w) => (
        <div key={w.versie} style={{ borderLeft: `3px solid ${w.versie === huidig ? 'var(--merk)' : 'var(--lijn)'}`, paddingLeft: 12 }}>
          <div className="rij wrap" style={{ gap: 8 }}>
            <b style={{ color: 'var(--accent-tekst)' }}>v{w.versie}</b>
            <span className="vet">{w.titel}</span>
            {w.versie === huidig && <span className="badge toon-oranje">huidige versie</span>}
          </div>
          <div className="klein mute">
            {fmtDag(w.datum, 'jaar')}
            {live && (live.get(w.versie) ? ` · live sinds ${new Date(live.get(w.versie)!).toLocaleString('nl-NL', { dateStyle: 'medium', timeStyle: 'short' })}` : ' · (live gegaan vóór de registratie van versies)')}
          </div>
          <ul style={{ margin: '4px 0 0', paddingLeft: 18 }}>
            {w.punten.map((p) => <li key={p} className="klein">{p}</li>)}
          </ul>
        </div>
      ))}
    </div>
  );
}
